<template>
  <v-card outlined class="mt-8">
    <v-card-title class="text-h6">
      Active Sessions
      <v-spacer></v-spacer>
      <v-btn
        small
        color="error"
        outlined
        :loading="signingOut"
        :disabled="loading || sessions.length < 2"
        @click="signOutOthers"
      >
        Sign out other devices
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div v-if="loading" class="text-center py-6">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else-if="sessions.length === 0" class="text-center basic--text py-6">
        No active sessions found.
      </div>
      <v-list v-else two-line class="py-0">
        <template v-for="(session, index) in sessions">
          <v-list-item :key="session.sessionId">
            <v-list-item-icon>
              <v-icon>mdi-devices</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ session.deviceDetails || 'Unknown device' }}
                <v-chip
                  v-if="session.current"
                  x-small
                  color="primary"
                  class="ml-2"
                >This device</v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>
                IP: {{ session.ipAddress || 'Unknown' }} ·
                Signed in {{ formatDate(session.issuedAt) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index < sessions.length - 1"
            :key="session.sessionId + '-divider'"
          ></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import Api from "@/main/api";

export default {
  name: "ActiveSessionsCard",

  data: () => ({
    sessions: [],
    loading: false,
    signingOut: false,
  }),

  methods: {
    fetchSessions() {
      this.loading = true;
      Api.auth
        .getSessions()
        .then((res) => {
          this.sessions = Array.isArray(res.data) ? res.data : [];
        })
        .catch(() => {
          this.$toast.open({
            message: "Could not load your active sessions.",
            type: "error",
            position: "top-right",
          });
        })
        .finally(() => (this.loading = false));
    },

    signOutOthers() {
      this.signingOut = true;
      Api.auth
        .logoutOthers()
        .then(() => {
          this.$toast.open({
            message: "Other devices have been signed out.",
            type: "success",
            position: "top-right",
          });
          this.fetchSessions();
        })
        .catch(() => {
          this.$toast.open({
            message: "Could not sign out other devices.",
            type: "error",
            position: "top-right",
          });
        })
        .finally(() => (this.signingOut = false));
    },

    formatDate(value) {
      if (!value) return "at an unknown time";
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleString();
    },
  },

  created() {
    this.fetchSessions();
  },
};
</script>

<style scoped></style>
